export default __webpack_public_path__ + "static/media/pexels-fauxels-3184433.79e2d40f.jpg";